import useMutation from "src/hooks/useMutation";

function useBankInfoCreate() {
  return useMutation({
    path: "/api/v1/bank-infos",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/bank-infos`,
      shouldRevalidate: true,
    },
  });
}

export default useBankInfoCreate;

